import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigation} from '@react-navigation/native';
import WebView, {WebViewNavigation} from 'react-native-webview';
import querystring from 'querystring';
import {loginSlice} from '../../../../../redux/reducers/login';
import {getApiRoute} from '../../../../../shared/pipes';
import {apiUrls} from '../../../../../shared/constants/urls';
import {HttpWrapperOptions, httpService} from '../../../../../shared/httpWrapper';
import {getTokenResponse} from '../../../../../shared/fcmWrapper/model';
import {fcmService} from '../../../../../shared/fcmWrapper';
import {AuthorizeEsiaRequestPayload} from '../../../../../shared/models/api/authorizeEsiaRequestPayload';
import {AuthorizeEsiaResponsePayload} from '../../../../../shared/models/api/authorizeEsiaResponsePayload';
import {Screens} from '../../../../../shared/routing';
import {useRegCardState} from '../../esiaRegCardState/useRegCardState';
import {addNotification} from '../../../../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../../../../../shared/components/snackbar/model';
import {useStyles} from '../../../../../shared/hooks/styles';
import {View} from 'react-native';

const LK_TEST_ESKSO = 'https://test-lk.eskso.ru';
const LK_PROD_ESKSO = 'https://lk.eskso.ru';
const LK_STAGE_ESKSO = 'https://stage-lk.eskso.ru';

export const EsiaLoginAfterLogged = () => {
  const styles = useStyles(() => ({
    root: {
      width: '100%',
      height: '100%',
    },
    webView: {
      borderRadius: 5,
    },
  }));

  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [link, setLink] = useState('');
  const {addData} = useRegCardState();

  const getNewLinkFromEsia = async () => {
    try {
      const esiaLink = await httpService.get<{link: string}>(
        getApiRoute(apiUrls.esiaGetLink),
        new HttpWrapperOptions()
          .AddText('ЗАГРУЗКА ДАННЫХ С ГОС УСЛУГ')
          .Errors(false)
          .ThrowException(false)
          .WaitTimeout(0)
          .Wait(true),
      );
      setLink(esiaLink.link);
    } catch (e) {
      dispatch(
        addNotification({
          message: String(e),
          type: SnackbarNotificationType.Error,
        }),
      );
      navigation.goBack();
    }
  };

  useEffect(() => {
    getNewLinkFromEsia();
  }, []);

  const onNavigationStateChange = ({url}: WebViewNavigation) => {
    if (!url || !(url.startsWith(LK_PROD_ESKSO) || url.startsWith(LK_TEST_ESKSO) || url.startsWith(LK_STAGE_ESKSO)))
      return;
    const [, params = ''] = url.split('?');
    const {code, state} = querystring.parse(params);
    if (code && state) {
      try {
        const updatingEsiaRegIndfo = (async () => {
          let fcmToken: getTokenResponse | null = null;
          try {
            fcmToken = await fcmService.getToken();
          } catch (error) {
            console.log(error);
          }
          const data: AuthorizeEsiaRequestPayload = {
            code: code as string,
            state: state as string,
            firebaseId: fcmToken?.token ?? null,
            previousFirebaseId: fcmToken?.previousToken ?? null,
          };
          try {
            const res = await httpService.post<AuthorizeEsiaResponsePayload>(
              getApiRoute(apiUrls.esiaLogin),
              data,
              new HttpWrapperOptions().WaitTimeout(0).Wait(true).ThrowException(false).Errors(false),
            );
            dispatch(loginSlice.actions.setEsiaRegistrationInfo(res));
            addData(res);
          } catch (e: any) {
            console.log(e);
          }
          navigation.navigate(Screens.EsiaRegistrationCardUserSelecting);
        })();
      } catch (e) {
        console.log(e);
      } finally {
        setLink('');
        return;
      }
    } else {
      navigation.goBack();
    }
  };

  return (
    <View style={styles.root}>
      <WebView
        link={link}
        goBack={navigation.goBack}
        onNavigationStateChange={onNavigationStateChange}
        scalesPageToFit
        startInLoadingState
        androidHardwareAccelerationDisabled
        thirdPartyCookiesEnabled
        cacheEnabled={false}
        mixedContentMode='compatibility'
        source={{uri: link ?? ''}}
        containerStyle={styles.webView}
      />
    </View>
  );
};
